import { Field as ChakraField } from '@chakra-ui/react';
import { InputNumberProps } from '@components/ui/input/InputNumber';
import { UnitNumberInput } from '@components/ui/input/InputNumberWithUnit';
import RequiredIndicator from '@components/ui/RequiredIndicator';
import { UnitTypeMap, UnitTypes } from '@utils/unit.utils';
import { hasChanged, isInvalid } from '@utils/validation/validation.utils';
import { Field, useFormikContext } from 'formik';
import { FormattedMessage } from 'react-intl';

import ModifiedTag from './ModifiedField';

type FormUnitNumberInputProps<U extends UnitTypes> = {
  label: string;
  i18nKey?: string;
  required?: boolean;
  unitType: U;
  defaultUnit?: UnitTypeMap[U];
  precision?: number;
} & InputNumberProps;

export function FormUnitNumberInput<T extends object, U extends UnitTypes>({
  label,
  i18nKey,
  required = true,
  unitType,
  ...rest
}: Readonly<FormUnitNumberInputProps<U>>) {
  const { initialValues, touched, errors, values, setFieldValue } = useFormikContext<T>();

  return (
    <ChakraField.Root
      variant="cockpit"
      required={required}
      invalid={required ? isInvalid(label, touched, errors) : false}
    >
      <ChakraField.Label width="100%" height="20px">
        <FormattedMessage id={i18nKey ?? `components.sensorInstallation.form.common.${label}`} />
        {required && <RequiredIndicator />}
        {hasChanged(label, initialValues, values) && <ModifiedTag />}
      </ChakraField.Label>

      <Field
        as={UnitNumberInput}
        name={label}
        unitType={unitType}
        {...rest}
        onChange={(value?: number) => setFieldValue(label, value ?? null)}
      />
    </ChakraField.Root>
  );
}
